module.exports = __webpack_public_path__ + "static/img/180153_5.a1ba5cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/180153_5.jpg
// module id = YVVY
// module chunks = 1